export function PostHistoryRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.PostHistory', {
		url: '/post/:id/history',
		controllerAs: 'vm',
		controller: PostHistoryCtrl,
		templateUrl: '/ng/hub/Post/History/PostHistoryCtrl.html?' + window.BUILD,
		resolve: {},
	});
}

export class PostHistoryCtrl {
	constructor($stateParams) {
		'ngInject';
		this.post = { id: $stateParams.id };
	}
}
